import { useForkRef } from '@consta/uikit/useForkRef'
import { useAutoResize, useLatest } from '@library/hooks'
import type { ClassNameProp } from '@library/types'
import cn from 'classnames'
import type { Nullable, Prettify } from 'common/types'
import type { PropsWithChildren } from 'react'
import { forwardRef, useEffect, useState } from 'react'

import css from './Content.css'

type ContentProps = Prettify<
  ClassNameProp & {
    onResize?: (width: number, height: number) => void
  }
>

export const Content = forwardRef<HTMLElement, PropsWithChildren<ContentProps>>(function Content(
  { children, onResize, className },
  ref,
) {
  const [element, setElement] = useState<Nullable<HTMLElement>>(null)
  const { height, width } = useAutoResize(element)
  const onResizeCallback = useLatest(onResize)

  const forkedRef = useForkRef([setElement, ref])

  useEffect(() => {
    onResizeCallback.current?.(width, height)
  }, [width, height])

  return (
    <section
      ref={forkedRef}
      className={cn(css.content, className)}
      style={{ '--max-fit-modal-height': `${height}px` }}>
      {children}
    </section>
  )
})
